import Vue from 'vue'

// axios
import axios from 'axios'

// Build-time env: dev'de boş → fallback http://localhost:3000/api/v1
// Docker prod'da Vue CLI build'i sırasında VUE_APP_API_URL=/api/v1 set edilir,
// nginx reverse proxy backend'e iletir.
const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3000/api/v1',
})

Vue.prototype.$http = axiosIns

export default axiosIns
